<template>
  <div class="address-card-container">
    <div class="title-container">
      <h3>Uw Rijnja vestiging:</h3>
      <!--  <close-button @click="$emit('close')" class="close-button"></close-button> -->
    </div>
    <div class="address-container" v-if="address">
      <p class="user-text">
        <span class="placeholder" v-if="shopEmpty">Selecteer een adres</span>
        {{ address.company }}<br />
        <span @click="openMap(address.url)" class="pointer">
          {{ address.street }} {{ address.number }}{{ address.addition }}</span
        ><br />
        {{ address.zipCode }} {{ address.city }}<br />
        <a class="user-text no-underline" :href="'tel:' + address.phone">{{
          address.phone
        }}</a
        ><br />
        <a class="user-text no-underline" :href="'mailto:' + address.email">{{
          address.email
        }}</a>
      </p>
    </div>
    <!--  <div
      class="vue-map-container pointer"
      @click="openMap(address.url)"
      v-if="shopImage"
      :style="shopImage"
    ></div> -->
  </div>
</template>

<script>
import isEmpty from 'lodash-es/isEmpty'

export default {
  props: ['address'],
  computed: {
    shopEmpty() {
      return isEmpty(this.address)
    },
    shopImage() {
      if (this.address.image) {
        return {
          backgroundImage: "url('../images/shops/" + this.address.image + "')"
        }
      } else {
        return false
      }
    }
  },
  methods: {
    openMap(url) {
      window.open(url)
    }
  }
}
</script>

<style lang="scss" scoped>
.address-card-container {
  display: flex;
  flex-direction: column;
  //  box-shadow: var(--default-shadow);
  //background: #f4f4f4;
  //padding: 20px;
  // border-radius: 25px;
  //  margin: -10px;
}
.vue-map-container {
  margin: 0 -15px -18px;
  height: 230px;
  display: none;
  bottom: 0;
  border-radius: 6px;
  overflow: hidden;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  @media only screen and (min-width: 620px) {
    display: block;
  }
}

.address-container {
  line-height: 24px;
  flex-grow: 1;
}
</style>
